import { render, staticRenderFns } from "./IconRotateRight.vue?vue&type=template&id=29068df8&"
import script from "./IconRotateRight.vue?vue&type=script&lang=ts&"
export * from "./IconRotateRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports